import React from 'react';

import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import connect from 'react-redux/lib/connect/connect';
import bindActionCreators from 'redux/lib/bindActionCreators';

import * as ReportDucks from 'ducks/reports/report';
import * as InfoDucks from 'ducks/info/info';

import TwoColumnLayout from 'layouts/TwoColumn';
import ReportListSection from 'sections/reports/dashboard/List';

import { NAV } from 'constants/reports';

/**
 * ReportDashboardPage
 *
 * Layout:
 *    - {@link TwoColumnLayout}
 *
 * Sections:
 *    - {@link ReportListSection}
 *
 * Fetch Needs:
 *    - getReports
 */
class ReportDashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, isInfoOpen: true };
    this.toggleInfo = this.toggleInfo.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  componentWillMount() {
    const cookieKey = cookie.load("report_info");
    if(cookieKey) {
      this.setState({isInfoOpen: JSON.parse(cookieKey)});
    }
    this.props.InfoDucks.getInformations({route: 'report.dashboard'});
    this.fetchData();
  }

  componentWillUnmount(){
    this.props.InfoDucks.resetInformations();
  }

  fetchData(){
    this.setState({ isLoading: true });
    return this.props.ReportDucks.getReports()
      .then(() => this.setState({ isLoading: false }))
      .catch(() => this.setState({ isLoading: false }));
  }

  toggleInfo(){
    const { isInfoOpen } = this.state;
    this.setState({ isInfoOpen: !isInfoOpen });
    cookie.save("report_info", !isInfoOpen);
  }

  render() {
    const { infoList } = this.props;
    const { isInfoOpen } = this.state;
    return (
      <TwoColumnLayout
        navInfo={NAV.ReportDashboardPage}
        infoList={infoList}
        isInfoOpen={isInfoOpen}
        toggleInfo={this.toggleInfo}
        fetchData={this.fetchData}
      >
        <ReportListSection isLoading={this.state.isLoading} />
      </TwoColumnLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  infoList: InfoDucks.infoList(state),
});

const mapActionsToProps = dispatch => ({
  ReportDucks: bindActionCreators(ReportDucks, dispatch),
  InfoDucks: bindActionCreators(InfoDucks, dispatch),
});

ReportDashboardPage.propTypes = {
  ReportDucks: PropTypes.object.isRequired,
  InfoDucks: PropTypes.object.isRequired,
  infoList: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(ReportDashboardPage);
